import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Home from './Home';
import About from './About';
import Scene from './Scene';
import Themes from './Themes';
import People from './People';
import reportWebVitals from './reportWebVitals';
import { Router, Link } from '@reach/router';
import Catalogue from './Catalogue';
import Credits from './Credits';
import Landing from './Landing';
import CookieConsent from 'react-cookie-consent';
import { isMobileWithTablet } from './utils';

ReactDOM.render(
  <React.StrictMode>
    <CookieConsent
      onAccept={() => {}}
      location="bottom"
      buttonText="Accetta e prosegui"
      style={{
        height: isMobileWithTablet ? '200px' : '100px',
      }}
      buttonStyle={{
        backgroundColor: '#458f8e',
        fontFamily: 'Sanuk',
      }}
    >
      Utilizziamo i cookie per migliorare la tua esperienza di navigazione e per
      aiutarci migliorare il nostro sito. Proseguendo nella navigazione si
      accetta l’uso dei cookies in caso contrario è possibile abbandonare il
      sito.
    </CookieConsent>
    <Router>
      <Landing path="/" default />
      <Home path="/home" />
      <About path="/about" />
      <Themes path="/themes" />
      <People path="/people" />
      <Scene path="/exhibit" />
      <Catalogue path="/catalogue" />
      <Credits path="/credits" />
    </Router>
  </React.StrictMode>,
  document.getElementById('root'),
);
